/**
 * RequirePlatformRole
 *
 * Inverse of RedirectPlatformToControlTower. Use to protect routes that must
 * be accessed only by Platform Owner / Platform Admin (e.g. Observability,
 * Tenant management). Tenant users are redirected to their tenant dashboard
 * to avoid landing on a shell with backend-403 errors.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";


export default function RequirePlatformRole({ children, fallback = "/dashboard" }) {
  const { isPlatform, checking } = useAuth();
  if (checking) return null;
  if (!isPlatform) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
